export const DefaultFlex = 'flex justify-between';
export const DefaultFlexCenter = 'flex justify-center';

const FontsDefault = {
  defaultContainerWidth: `md:py-20 py-16 lg:w-9/12 w-11/12  mx-auto text-textColor`,
  defaultContainer: `md:py-24 py-16 lg:w-9/12 w-11/12  md:${DefaultFlex} lg:flex-row flex md:flex-col flex-col mx-auto text-textColor`,
  defaultGridContainer: `grid lg:grid-rows-2 gap-8`,
  defaultContainerSliderImage: `h-128 w-full shadow-lg shadow-gray800 bg-white`,
  defaultServicesCard: `mt-4 p-4 shadow-md shadow-gray300 border-1 border-gray700 cursor-pointer w-11/12 ${DefaultFlex} mx-auto rounded hover:bg-amber hover:text-textColor hover:border-amber`,
  textBold: 'text-lg font-bold',
  styleAboutContent: 'w-40 justify-center text-center',
  fontSizeAbout: `text-4xl font-bold text-amber`,
  text2xl: 'text-2xl',
  text3xl: 'text-3xl',
  text4xl: 'text-4xl',
  text6xl: 'text-6xl',
  textCenter: 'justify-center text-center',
  contentNav: `text-black hover:bg-amber hover:text-textColor px-3 py-2 rounded-md text-lg font-medium`,
};

export default FontsDefault;
